import { useState } from 'react';
import * as React from 'react';
import { toast } from 'react-toastify';
import { personalakteStyles as ps, colors, shadows } from '../styles/personalakteStyles';

interface AddEmployeeModalProps {
  open: boolean;
  onClose: () => void;
  onInvite: (data: { first_name: string; last_name: string; email: string }) => void;
}

const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.4)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle: React.CSSProperties = {
  background: colors.bgCard,
  padding: '24px',
  borderRadius: '16px',
  width: '100%',
  maxWidth: '400px',
  boxShadow: shadows.elevated,
};

function AddEmployeeModal({ open, onClose, onInvite }: AddEmployeeModalProps) {
  const [newEmpData, setNewEmpData] = useState({ first_name: '', last_name: '', email: '' });

  if (!open) return null;

  const handleInvite = () => {
    if (!newEmpData.first_name || !newEmpData.last_name || !newEmpData.email) {
      toast.error('Bitte alle Felder ausfüllen!');
      return;
    }
    onInvite(newEmpData);
    setNewEmpData({ first_name: '', last_name: '', email: '' });
  };

  const handleClose = () => {
    setNewEmpData({ first_name: '', last_name: '', email: '' });
    onClose();
  };

  return (
    <div data-testid="modal-overlay" style={modalOverlayStyle} onClick={handleClose}>
      <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 data-testid="add-modal-title" style={{ margin: 0, color: colors.navy, fontSize: 16, fontWeight: 700 }}>New Employee</h3>
          <button
            onClick={handleClose}
            style={{
              background: colors.bgMuted,
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: colors.textMuted,
              padding: '0',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.background = colors.bgHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = colors.bgMuted; }}
            title="Close"
          >
            ×
          </button>
        </div>
        <div style={{ ...ps.fieldWrapper, marginBottom: 12 }}>
          <label style={ps.labelStyle}>First Name</label>
          <input
            data-testid="input-first-name"
            type="text"
            value={newEmpData.first_name}
            onChange={(e) => setNewEmpData({ ...newEmpData, first_name: e.target.value })}
            style={ps.inputStyle}
          />
        </div>
        <div style={{ ...ps.fieldWrapper, marginBottom: 12 }}>
          <label style={ps.labelStyle}>Last Name</label>
          <input
            data-testid="input-last-name"
            type="text"
            value={newEmpData.last_name}
            onChange={(e) => setNewEmpData({ ...newEmpData, last_name: e.target.value })}
            style={ps.inputStyle}
          />
        </div>
        <div style={{ ...ps.fieldWrapper, marginBottom: 12 }}>
          <label style={ps.labelStyle}>Email</label>
          <input
            data-testid="input-email"
            type="email"
            value={newEmpData.email}
            onChange={(e) => setNewEmpData({ ...newEmpData, email: e.target.value })}
            style={ps.inputStyle}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '16px' }}>
          <button
            data-testid="cancel-button"
            className="hover-btn-secondary"
            onClick={handleClose}
            style={ps.buttonSecondary}
          >
            Cancel
          </button>
          <button
            data-testid="invite-button"
            className="hover-btn-primary"
            onClick={handleInvite}
            style={ps.buttonPrimary}
          >
            Invite
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddEmployeeModal;
